import { useEffect, useState } from "react";
import "./loader.scss";
import { Progress } from "reactstrap";
import { Mainlogo, projectName } from "../../components/common/constant";

const Loader = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => prev < 95 ? prev + 1 : prev);
      // setCount((prev) => (prev === 100 ? 0 : prev) + 1);
    }, 100);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fallback-spinner">
      <div className="loading">
        <img src={Mainlogo} alt={projectName} width="120px" height="auto" />
        <Progress animated className="my-2" color="primary" value={count} />
        {/* <Spinner color="primary" /> */}
      </div>
    </div>
  );
};
export default Loader;
